import {Request} from "citrus.plugins.request";

export class VuexBasketRestClient {
	constructor(id, quantity) {
		this.actionPrefix = "citrus:restsale.api.basket.";
		this.id = id;
		this.quantity = quantity;
		this.request = new Request();

		this.request.setModeModule();

		return this;
	}

	getQuantity() {
		return this.quantity;
	}

	setQuantity(value = null) {
		this.quantity = value;
		return this;
	}

	getId() {
		return this.id;
	}

	setId(id = null) {
		this.id = id;
		return this;
	}

	clean() {
		return this.request
			.setAction(this.actionPrefix + "clean")
			.setData({
				SITE_ID: BX.message("SITE_ID")
			})
			.send()
			;
	}

	remove() {
		return this.request
			.setAction(this.actionPrefix + "remove")
			.setData({
				id: this.getId(),
				SITE_ID: BX.message("SITE_ID")
			})
			.send()
			;
	}

	load() {
		return this.request
			.setAction(this.actionPrefix + "getList")
			.setData({
				SITE_ID: BX.message("SITE_ID")
			})
			.send()
			;
	}

	add() {
		return this.request
			.setAction(this.actionPrefix + "add")
			.setData({
				id: this.getId(),
				quantity: this.getQuantity(),
				SITE_ID: BX.message("SITE_ID")
			})
			.send()
			;
	}

	update() {
		return this.request
			.setAction(this.actionPrefix + "update")
			.setData({
				id: this.getId(),
				quantity: this.getQuantity(),
				SITE_ID: BX.message("SITE_ID")
			})
			.send()
			;
	}
}
